<template>
    <sub-menu id="digital-signage">
        <sub-menu-item to="/digital-signage|/affichage-numerique" icon="fa-tv-alt">
            <span v-tr>Digital Signage|Affichage numérique</span>
        </sub-menu-item>
        <sub-menu-item to="/digital-signage/videowalls|/affichage-numerique/mur-ecrans-video" icon="fa-gallery-thumbnails">
            <span v-tr>Video Wall|Murs vidéo</span>
        </sub-menu-item>
        <sub-menu-item to="/digital-signage/interactive-touch-kiosk|/affichage-numerique/kiosk-tactile-interactif" icon="fa-rectangle-vertical-history">
            <span v-tr>Wayfinding Kiosk|Kiosque tactile de navigation</span>
        </sub-menu-item>
        <sub-menu-item to="/digital-signage/holograms|/affichage-numerique/hologrammes" icon="fa-atom">
            <span v-tr>3D Holograms|Hologrammes 3D</span>
        </sub-menu-item>
        <sub-menu-divider/>
        <sub-menu-item to="/digital-signage/menuboards|/affichage-numerique/menus-restaurants" icon="fa-utensils">
            <span v-tr>Digital Menu Boards|Menus numérique</span>
        </sub-menu-item>
        <sub-menu-item to="/digital-signage/healthcare|/affichage-numerique/sante-et-hopitaux" icon="fa-hospital">
            <span v-tr>Signage for Healthcare|Affichage pour la santé</span>
        </sub-menu-item>
        <sub-menu-item to="/digital-signage/schools-and-education|/affichage-numerique/ecoles-et-education" icon="fa-graduation-cap">
            <span v-tr>Signage for Education|Affichage pour l'éducation</span>
        </sub-menu-item>
        <sub-menu-divider/>
        <sub-menu-item to="/digital-signage/storyboard/infinite|/affichage-numerique/storyboard/infinite" icon="fa-paint-brush-alt">
            <span v-tr>Content Design Software|Création de contenu</span>
        </sub-menu-item>
<!--        <sub-menu-item to="/digital-signage/technology" icon="fa-tv-alt">-->
<!--            <span v-tr>Equipment & Compatibility</span>-->
<!--        </sub-menu-item>-->
        <sub-menu-item to="/digital-signage/services|/affichage-numerique/services" icon="fa-tools">
            <span v-tr>Our Services|Nos services</span>
        </sub-menu-item>
        <sub-menu-item to="/digital-signage/clients|/affichage-numerique/clients" icon="fa-users-crown">
            <span v-tr>Our Markets & Clients|Nos clients et marchés</span>
        </sub-menu-item>
    </sub-menu>
</template>

<script>

import SubMenuItem from "@/components/sub-menu-item.vue";
import SubMenu from "@/components/sub-menu.vue";
import SubMenuDivider from "../components/sub-menu-divider.vue";
export default {
    name: `digital-signage-navigation`,
    components: {SubMenuDivider, SubMenuItem, SubMenu}
}
</script>

<style lang="scss" scoped>
</style>
